<div class="ip-profiles-summary">
  <div *ngIf="!selection" class="arm-summary">0 Items selected</div>
  <div *ngIf="selection" class="arm-summary">
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name" fxFlex="45">Name:</span>
      <span class="arm-summary-value" [title]="selection.name" fxFlex>{{selection.name}}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name" fxFlex="45">SBC Media Security Mode:</span>
      <span class="arm-summary-value" [title]="selection.sbcMediaSecurityMode" fxFlex>{{selection.sbcMediaSecurityMode}}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name" fxFlex="45">Remote 3xx Mode:</span>
      <span class="arm-summary-value" [title]="selection.sbcRemote3xxBehavior" fxFlex> {{selection.sbcRemote3xxBehavior}} </span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name" fxFlex="45">Remote REFER Mode:</span>
      <span class="arm-summary-value" [title]="selection.sbcRemoteReferBehavior" fxFlex> {{selection.sbcRemoteReferBehavior}} </span>
    </div>

    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name" fxFlex="45">Remote Replaces Mode:</span>
      <span class="arm-summary-value" [title]="selection.sbcRemoteReplacesBehavior" fxFlex> {{selection.sbcRemoteReplacesBehavior}} </span>
    </div>

    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name" fxFlex="45">ICE Mode:</span>
      <span class="arm-summary-value" [title]="selection.iceMode" fxFlex> {{selection.iceMode}} </span>
    </div>

    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name" fxFlex="45">SIP UPDATE Support:</span>
      <span class="arm-summary-value" [title]="selection.sipUpdateSupport" fxFlex> {{selection.sipUpdateSupport}} </span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name" fxFlex="45">Remote re-INVITE:</span>
      <span class="arm-summary-value" [title]="selection.remoteReInvite" fxFlex> {{selection.remoteReInvite}} </span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name" fxFlex="45">Remote Delayed Offer Support:</span>
      <span class="arm-summary-value" [title]="selection.remoteDelayedOfferSupport" fxFlex> {{selection.remoteDelayedOfferSupport}} </span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name" fxFlex="45">Remote Representation Mode:</span>
      <span class="arm-summary-value" [title]="selection.representationMode" fxFlex> {{selection.representationMode}} </span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name" fxFlex="45">Remote Hold Format:</span>
      <span class="arm-summary-value" [title]="selection.remoteHoldFormat" fxFlex> {{selection.remoteHoldFormat}} </span>
    </div>
  </div>
</div>
